import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import * as R from 'ramda'
import { WindowMU } from "app/types/WindowMU";

declare var window:WindowMU

export async function alterarFreteItemOrcamento({
    identificadorItem, idTipoFreteOuFreteEspecial,  ehFreteEspecial
}: {
    identificadorItem:number, 
    idTipoFreteOuFreteEspecial:number, 
    ehFreteEspecial:boolean
}) {
    const identificadorOrcamento = store.getState().orcamento.IdentificadorOrcamento

    const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarFreteItemOrcamento(identificadorOrcamento, identificadorItem, idTipoFreteOuFreteEspecial, ehFreteEspecial)

    window.orcamentoController.model.atualizar(orcamentoAtualizado,true,true,true)

    
}